// Resolve the existing save/apply control inside the editor being closed.
// Never infer business methods or promote a save to finalization/emission.
const dialogs = '.modal, [role="dialog"], .produto-overlay'
const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase()
const visible = element => element.isConnected && element.getClientRects().length > 0 && !['hidden', 'collapse'].includes(getComputedStyle(element).visibility)
const layer = element => {
  let value = 0
  for (let current = element; current; current = current.parentElement) {
    value = Math.max(value, Number.parseFloat(getComputedStyle(current).zIndex) || 0)
  }
  return value
}

export function editingSaveAction(pending) {
  const modals = pending.filter(scope => scope.modal)
  // Prefer the uppermost editor. Never save a parent behind an unfinished child.
  const scope = modals.sort((left, right) => {
    if (left.element.contains(right.element)) return 1
    if (right.element.contains(left.element)) return -1
    return layer(right.element) - layer(left.element)
  })[0] || pending[0]
  if (!scope) return null
  const candidates = [...scope.element.querySelectorAll('button, input[type="submit"], [data-editing-save]')]
    .filter(control => visible(control) && !control.closest('[data-editing-ignore], .rotina-list-toolbar, .commercial-tree-toolbar, .swal2-container') &&
      (scope.modal ? control.closest(dialogs) === scope.element : !control.closest(dialogs)))
    .map(control => {
      const label = normalize(control.getAttribute('aria-label') || control.textContent?.trim() || control.value || control.title)
      let score = 0
      if (control.hasAttribute('data-editing-save')) score = 100
      else if (/\b(finalizar|emitir|excluir|exclusao|remover|cancelar|cancelamento|estornar|estorno)\b/.test(label)) return null
      else if (label === 'salvar' || label === 'salvar alteracoes') score = 90
      else if (/^salvar(?:\b|$)/.test(label)) score = 80
      else if (control.type === 'submit' && control.form) score = 70
      else if (/^(aplicar|confirmar|lancar)(?:\b|$)/.test(label) && control.closest('.modal-footer, .card-footer')) score = 60
      return score ? { control, score: score + (control.closest('.modal-footer, .card-footer') ? 5 : 0) } : null
    }).filter(Boolean).sort((left, right) => right.score - left.score)
  const control = candidates[0]?.control
  if (!control) return null
  return {
    control,
    get enabled() { return visible(control) && !control.matches(':disabled, [aria-disabled="true"]') },
    run() {
      if (this.enabled) control.click()
    }
  }
}
